// Where the "purchase" call-to-action sends customers.
// Purchases happen on the Wix storefront; the app remains a redemption /
// entitlement surface only. Keep this in one place so future URL changes are
// a single-line edit.
export const WIX_STORE_URL = "https://www.paranormalarchetypes.net/category/all-products";

// Opens the Wix storefront in the customer's normal browser / new tab.
// Never navigate away in-place — customers must be able to return to the app.
export function openWixStore() {
  try {
    window.open(WIX_STORE_URL, "_blank", "noopener,noreferrer");
  } catch {
    // Extremely defensive fallback for environments that block window.open;
    // navigate in-place so the customer still reaches the store.
    window.location.href = WIX_STORE_URL;
  }
}
